namespace $.$$ {
	export class $eve_app_page_components_checkbox extends $.$eve_app_page_components_checkbox {}
}

